import { Link, useLocation } from "react-router-dom";
import "./breadcrumbnav.scss";

const NAME_MAP = {
    Articles: 'Articles',
    FaceCream: 'For Face',
    BodyWash: 'For Body',
    Soaps: 'Soaps',
    Shop: 'Shop',
};

function Breadcrumbs({ specificOption, titlePost }) {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(Boolean);
    
    const staticLabel = pathnames[0] === 'DynamicPosts'
        ? titlePost
        : NAME_MAP[pathnames[0]] ?? pathnames[0];

    // The bar gives every page the same layout (the shop page's), so put this at the top of the
    // page, not inside a narrower content column.
    return (
        <nav className="breadcrumb-bar" aria-label="Breadcrumb">
            <div className="breadcrumbNavContainer">
                <Link className="breadcrumbNav" to="/">Home</Link>
                {specificOption && (
                    <>
                        <span className="breadcrumb-arrow"> / </span>
                        <Link className="breadcrumbNav" to={`/${specificOption}`}>
                            {NAME_MAP[specificOption] ?? specificOption}
                        </Link>
                    </>
                )}
                {specificOption && titlePost && (
                    <>
                        <span className="breadcrumb-arrow"> / </span>
                        <span className="breadcrumbNav">{titlePost}</span>
                    </>
                )}
                {!specificOption && pathnames.length > 0 && (
                    <>
                        <span className="breadcrumb-arrow"> / </span>
                        <span className="breadcrumbNav">{staticLabel}</span>
                    </>
                )}
            </div>
        </nav>
    );
}

export default Breadcrumbs;
